import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_guards';
import { Role } from './_models';

const routes: Routes = 
[

{ path: 'admin-auth', loadChildren: () => import('./admin-auth/admin-auth.module').then(m => m.AdminAuthModule) }, 
{ path: '' , 
  redirectTo: 'admin-auth', 
  pathMatch: 'full',
},

{ path: 'admin-common', loadChildren: () => import('./admin-common/admin-common.module').then(m => m.AdminCommonModule) },
 { path: '' , 
  redirectTo: 'admin-common', 
  pathMatch: 'full',
  canActivate: [AuthGuard], 
  data: { roles: [Role.Admin]}
},




];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
